import Routes from '../routing/routes'

export type InsightsTicketsListState = {
  searchFilter?: string
  selectedFilter?: string
  page?: number
  filterData?: any
  /** Date filter as [startDate, endDate] in MM-DD-YYYY. */
  dateRange?: string[] | null
}

export function readInsightsTicketsListState(location: any): InsightsTicketsListState | null {
  return location?.state?.listState || null
}

export function insightsTicketsListLocation(listState?: InsightsTicketsListState | null) {
  return {
    pathname: Routes.issuetracker,
    state: listState ? { listState } : undefined,
  }
}

export function goToInsightsTicketsList(history: any, location?: any) {
  history.push(insightsTicketsListLocation(readInsightsTicketsListState(location || history?.location)))
}
